import { put, takeLatest } from 'redux-saga/effects'
import { loadInvitation as load } from '../api/acceptInvitationLoad'
import {
  loadInvitationSucceeded,
  loadInvitationFailed
} from '../../actions/acceptInvitation'
import { ACCEPT_INVITATION_LOAD } from '../../constants/action.types'
import executeSaga from './helpers/executeSaga'

export function* loadInvitation({ request }, action) {
  const { invitationToken } = action.payload
  const data = {
    invitationToken: invitationToken
  }

  yield executeSaga(
    request,
    data,
    result => put(loadInvitationSucceeded(result)),
    () => put(loadInvitationFailed())
  )
}

export default function*({ request } = { request: load }) {
  yield takeLatest(ACCEPT_INVITATION_LOAD, loadInvitation, { request })
}
